export const LIBRARY_TYPE_LABELS: Record<string, string> = {
  rich_text: 'Texto enriquecido',
  video: 'Video',
  pdf: 'Documento PDF',
  pdf_folder: 'Carpeta de PDF',
  image: 'Imagen',
  audio: 'Audio',
  download: 'Archivo descargable',
  html: 'HTML',
  external_link: 'Enlace externo',
  h5p: 'H5P',
  assessment: 'Evaluación',
  scorm: 'SCORM',
  xapi: 'xAPI',
  cmi5: 'cmi5',
};

export const LIBRARY_STATUS_LABELS: Record<string, string> = {
  draft: 'Borrador',
  published: 'Publicado',
  archived: 'Archivado',
};

export const LIBRARY_STATUS_BADGE: Record<string, { className: string; icon: string; fill?: boolean }> = {
  published: { className: 'lib-show-badge lib-show-badge--published', icon: 'check_circle', fill: true },
  draft: { className: 'lib-show-badge lib-show-badge--draft', icon: 'edit_note' },
  archived: { className: 'lib-show-badge lib-show-badge--archived', icon: 'archive' },
};
